<div class="dob-wrapper" [ngClass]="isMobileView ? 'mobile' : ''">
	<form [formGroup]="dobForm">
		<div class="row">
			<div [ngClass]="!isMobileView ? 'col-4' : 'col-5'">
				<mat-form-field [floatLabel]="floatLabel" class="form-group month">
					<mat-label *ngIf="fieldLabel">{{ fieldLabel }}</mat-label>
					<mat-select
						disableOptionCentering
						panelClass="custom-material-position"
						placeholder="{{ placeHolderMonth }}"
						formControlName="month">
						<mat-option *ngFor="let month of months" [value]="month.id"> {{ month.value }} </mat-option>
					</mat-select>
					<mat-error>
						<app-error-message [control]="'month'"></app-error-message>
					</mat-error>
				</mat-form-field>
			</div>
			<div [ngClass]="!isMobileView ? 'col-4' : 'col-3'">
				<mat-form-field [floatLabel]="floatLabel" class="form-group day">
					<mat-label *ngIf="fieldLabel">
						<span *ngIf="labelOnEveryField">{{ fieldLabel }}</span>
					</mat-label>
					<mat-select
						disableOptionCentering
						panelClass="custom-material-position"
						placeholder="{{ placeHolderDay }}"
						formControlName="day">
						<mat-option *ngFor="let day of days" [value]="day"> {{ day }} </mat-option>
					</mat-select>
					<mat-error>
						<app-error-message [control]="'day'"></app-error-message>
					</mat-error>
				</mat-form-field>
			</div>
			<div class="col-4">
				<mat-form-field [floatLabel]="floatLabel" class="form-group year">
					<mat-label *ngIf="fieldLabel">
						<span *ngIf="labelOnEveryField">{{ fieldLabel }}</span>
					</mat-label>
					<mat-select
						disableOptionCentering
						panelClass="custom-material-position"
						placeholder="{{ placeHolderYear }}"
						formControlName="year">
						<mat-option *ngFor="let year of years" [value]="year"> {{ year }} </mat-option>
					</mat-select>
					<mat-error>
						<app-error-message [control]="'year'"></app-error-message>
					</mat-error>
				</mat-form-field>
			</div>
		</div>
	</form>
</div>
